
function deepCompareFields(obj1, obj2, fieldsToCheck) {
    // Handle exact same reference
    if (obj1 === obj2) return false;
    
    // Handle null/undefined cases
    if (obj1 === null || obj1 === undefined || obj2 === null || obj2 === undefined) {
        return obj1 !== obj2;
    }
    
    // Handle different types
    if (typeof obj1 !== typeof obj2) {
        return true;
    }
    
    // Handle primitive types
    if (typeof obj1 !== 'object') {
        return obj1 !== obj2;
    }
    
    // Handle arrays
    if (Array.isArray(obj1) && Array.isArray(obj2)) {
        if (obj1.length !== obj2.length) return true;
        
        for (let i = 0; i < obj1.length; i++) {
            if (deepCompareFields(obj1[i], obj2[i], fieldsToCheck)) {
                return true;
            }
        }
        return false;
    }
    
    // One is array, other is not
    if (Array.isArray(obj1) !== Array.isArray(obj2)) {
        return true;
    }
    
    // Handle objects - only check specified fields
    for (let field of fieldsToCheck) {
        const hasField1 = field in obj1;
        const hasField2 = field in obj2;
        
        // If field exists in one but not the other
        if (hasField1 !== hasField2) {
            return true;
        }
        
        // If field exists in both, compare values
        if (hasField1 && hasField2) {
            if (deepCompareFields(obj1[field], obj2[field], fieldsToCheck)) {
                return true;
            }
        }
    }
    
    return false;
}

export {deepCompareFields}